/**
 * 判断值是否为 null
 * @return 是否为 null
 */
export default function isNull(value) {
    return value === null;
}
//# sourceMappingURL=is-null.js.map